import type { ApiRace } from '../../types/apiRace';
import type { Race } from '@api/types';

const adaptValidTrackCondition = (
  value: ApiRace['trackCondition'] | null
): Race['trackCondition'] => {
  if (!value) {
    return null;
  }
  const { measure, label, code, measureTimestamp } = value;
  if (!label || !measure) {
    return null;
  }

  return {
    measureTimestamp,
    measure,
    code,
    label,
  };
};

const adaptTrackCondition = (
  trackCondition: ApiRace['trackCondition'],
  trackConditionForecast: ApiRace['trackConditionForecast']
): Race['trackCondition'] => {
  if (trackCondition) {
    return adaptValidTrackCondition(trackCondition);
  }

  return adaptValidTrackCondition(
    trackConditionForecast
      ? {
          measureTimestamp: trackConditionForecast.measureTimestamp || null,
          measure: trackConditionForecast.measureValue?.measure || null,
          label: trackConditionForecast.measureValue?.label || null,
          code: trackConditionForecast.measureValue?.code || null,
        }
      : null
  );
};

export { adaptTrackCondition };
